import React from 'react';
import { Icons } from '@cambridgeassessment/cambridge-ui';
import { TableColumn } from '@cambridgeassessment/cambridge-ui/build/components/Table/Table';
import { Entry } from '@cambridgeassessment/lib-ee-commons/src/domain/db';
import { SortTypes, resolveSortOrder, TableSortConfig } from './helpers';
import { TitleIconWrapper } from './ManageSampleChanges.styles';

export const baseTableCols = (
  sortConfig: TableSortConfig | undefined,
  setSortConfig: (config: TableSortConfig | undefined) => void,
  isPartOfConsortia: boolean,
  maxMark?: number,
  dataQaId?: string,
): TableColumn<Entry>[] => {
  return [
    {
      renderHeaderCell: function render() {
        return (
          <TitleIconWrapper>
            <div data-qa-id={'header-learner-number-name-cell'}>Candidate number and name</div>
            <Icons.Arrows selected={sortConfig?.sortField === SortTypes.CandidateNr} />
          </TitleIconWrapper>
        );
      },
      renderCell: function render(item) {
        return (
          <div data-qa-id={`${dataQaId}-learner-name-${item.learner.number}`}>{`${item.learner?.number
            .toString()
            .padStart(4, '0')} - ${item.learner?.name}`}</div>
        );
      },
      onHeaderClick: () => {
        resolveSortOrder(SortTypes.CandidateNr, setSortConfig, sortConfig);
      },
    },
    {
      renderHeaderCell: function render() {
        return (
          isPartOfConsortia && (
            <TitleIconWrapper data-qa-id='header-learner-centre-table'>
              <div>Centre</div>
              <Icons.Arrows selected={sortConfig?.sortField === SortTypes.Centre} />
            </TitleIconWrapper>
          )
        );
      },
      renderCell: function renderCol(item) {
        return (
          <div data-qa-id={`${dataQaId}-learner-centre-${item.learner.number}-${item.centreId}-cell`}>
            {isPartOfConsortia && item.centreId}
          </div>
        );
      },
      onHeaderClick: isPartOfConsortia
        ? () => resolveSortOrder(SortTypes.Centre, setSortConfig, sortConfig)
        : undefined,
      align: 'left',
    },
    {
      renderHeaderCell: function render() {
        return (
          <TitleIconWrapper>
            <div data-qa-id={'header-learner-mark-cell'}>Mark</div>
            <Icons.Arrows selected={sortConfig?.sortField === SortTypes.Mark} />
          </TitleIconWrapper>
        );
      },
      renderCell: function render(item) {
        return (
          <div data-qa-id={`${dataQaId}-learner-mark-${item.learner.number}`}>
            {item.mark}/{maxMark}
          </div>
        );
      },
      onHeaderClick: () => {
        resolveSortOrder(SortTypes.Mark, setSortConfig, sortConfig);
      },
      align: 'left',
    },
  ];
};
